export interface Asset {
  id: string;
  name: string;
  amount: number;
  interestRate: number; // Annual interest rate in percentage
  volatility: number; // Standard deviation of annual returns in percentage
  annualContribution: number; // Annual contribution amount until retirement
}

export interface UserInfo {
  currentAge: number;
  retirementAge: number;
  annualExpenses: number;
}

export enum WithdrawalStrategy {
  CONSTANT_PERCENTAGE = "Constant Percentage",
  GUARDRAILS = "Guardrails"
}

export interface SimulationResult {
  years: number[];
  portfolioValues: number[];
  withdrawals: number[];
  successProbability: number;
  medianEndingValue: number;
  worstCaseEndingValue: number;
  bestCaseEndingValue: number;
}

export interface ProjectionOptions {
  yearsToProject: number;
  withdrawalStrategy: WithdrawalStrategy;
  withdrawalRate: number; // Annual withdrawal rate in percentage
  simulationRuns: number; // Number of Monte Carlo simulations to run
}